// src/components/icons/Icon.tsx
import React from 'react';
import { ReactComponent as DashboardIcon } from '../../assets/icons/dashboard.svg';
import { ReactComponent as ClientListIcon } from '../../assets/icons/clientList.svg';
import { ReactComponent as ProcurementIcon } from '../../assets/icons/procurement.svg';
import { ReactComponent as MaintenanceIcon } from '../../assets/icons/maintenance.svg';
import { ReactComponent as ComplianceIcon } from '../../assets/icons/compliance.svg';
import { ReactComponent as DisposalIcon } from '../../assets/icons/disposal.svg';
import { ReactComponent as ReportsIcon } from '../../assets/icons/reports.svg';
import { ReactComponent as GearIcon } from '../../assets/icons/manufacturing.svg';
import { ReactComponent as UserCircleIcon } from '../../assets/icons/userCircle.svg';
import { ReactComponent as Passkey } from '../../assets/icons/passkey.svg';
import { ReactComponent as Success } from '../../assets/icons/success.svg';
import { ReactComponent as OpenEye } from '../../assets/icons/openEye.svg';
import { ReactComponent as ClosedEye } from '../../assets/icons/closedEye.svg';
import { ReactComponent as Inventory } from '../../assets/icons/inventory.svg';
import { ReactComponent as File } from '../../assets/icons/file.svg';
import { ReactComponent as InboxText } from '../../assets/icons/inboxText.svg';
import { ReactComponent as Notification } from '../../assets/icons/notifications.svg';
import { ReactComponent as Docx } from '../../assets/icons/docx.svg';
import { ReactComponent as PDF } from '../../assets/icons/pdf.svg';
import { ReactComponent as Folder } from '../../assets/icons/folder.svg';
import { ReactComponent as Archive } from '../../assets/icons/archive.svg';


type IconName =
  | 'dashboard'
  | 'clientlist'
  | 'procurement'
  | 'maintenance'
  | 'compliance'
  | 'disposal'
  | 'reports'
  | 'gear'
  | 'passkey'
  | 'userCircle'
  | 'success'
  | 'openEye'
  | 'closedEye'
  | 'file'
  | 'inventory'
  | 'inboxText'
  | 'notification'
  | 'docx'
  | 'pdf'
  | 'folder'
  | 'archive';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  name: IconName;
  size?: number;
}

const iconMap: Record<IconName, React.FC<React.SVGProps<SVGSVGElement>>> = {
  dashboard: DashboardIcon,
  clientlist: ClientListIcon,
  procurement: ProcurementIcon,
  maintenance: MaintenanceIcon,
  compliance: ComplianceIcon,
  disposal: DisposalIcon,
  reports: ReportsIcon,
  gear: GearIcon,
  passkey: Passkey,
  userCircle: UserCircleIcon,
  success: Success,
  openEye: OpenEye,
  closedEye: ClosedEye,
  inventory: Inventory,
  file: File,
  inboxText: InboxText,
  notification: Notification,
  docx: Docx,
  pdf: PDF,
  folder: Folder,
  archive: Archive,
};

const Icon: React.FC<IconProps> = ({ name, size = 20, ...props }) => {
  const SvgIcon = iconMap[name];
  return <SvgIcon width={size} height={size} {...props} />;
};

export default Icon;
